import AppCurrency from '../../lib/interfaces/AppCurrency';
import { reducer } from './reducer';

// -----------------
// STATE - This defines the type of data maintained in the Redux store.

export interface CurrencySettingsState {
    app: AppCurrency | undefined,
    //user: UserCurreny //add when needed, might be better adding to user settings
}

// -----------------
// ACTIONS - These are serializable (hence replayable) descriptions of state transitions.
// They do not themselves have any side-effects; they just describe something that is going to happen.

interface SetAppCurrencyAction {
  type: "SET_APP_CURRENCY";
  appStatePassedIn: AppCurrency
}

// Declare a 'discriminated union' type. This guarantees that all references to 'type' properties contain one of the
// declared type strings (and not any other arbitrary string).
export type KnownOrderPadAction = SetAppCurrencyAction;

export const unloadedAppCurrencySettingsState: CurrencySettingsState = { 
  app: undefined
};

export { reducer };